import { StyleSheet } from 'react-native';
import { SEPARATOR_STROKE, SIZES } from '../../../constants';

export default StyleSheet.create({
  root: {
  },
  separator: {
    marginHorizontal: SIZES.appHorizontalSpace,
  },
  separatorBorder: {
    height: 1,
    backgroundColor: SEPARATOR_STROKE,
  },
});

export const SeparatorFullWidth = StyleSheet.create({
  separator: {
    marginHorizontal: 0,
  },
});
